export default __webpack_public_path__ + "static/media/HAMBURGER MENU (close).f78f99dd.svg";